import React, { useEffect } from 'react';
import useStore from '../store/useStore';
import { getStatus } from '../services/api';

const StatusIndicator = () => {
  const systemStatus = useStore((state) => state.systemStatus);
  const setSystemStatus = useStore((state) => state.setSystemStatus);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        await getStatus();
        setSystemStatus('connected');
      } catch (error) {
        setSystemStatus('disconnected');
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 30000); // Check every 30s
    return () => clearInterval(interval);
  }, [setSystemStatus]);

  return (
    <div className="flex items-center gap-2">
      <div className={`w-2 h-2 rounded-full ${systemStatus === 'connected' ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]' : 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.5)] animate-pulse'}`}></div>
      <span className="text-xs text-gray-400 uppercase tracking-widest font-medium">
        {systemStatus === 'connected' ? 'System Online' : 'System Offline'}
      </span>
    </div>
  );
};

export default StatusIndicator;
